import React from "react";

import { Icon } from "@hireart/component-library";
import briefcaseIcon from "hireart-icons/briefcase.svg";
import clockIcon from "hireart-icons/clock.svg";
import companyIcon from "hireart-icons/company.svg";
import globeIcon from "hireart-icons/globe.svg";
import mapPinIcon from "hireart-icons/map-pin.svg";
import moneyIcon from "hireart-icons/money.svg";
import _ from "lodash";
import { Header } from "semantic-ui-react";
import styled from "styled-components";

const IconText = styled.div`
  margin-bottom: 8px;
`;

const workAmountMapping = {
  full_time: "Full time",
  part_time: "Part time",
};

const jobDetailsMapping = {
  modality: (modality) => ({
    header: "Work environment",
    content: modality,
    icon: globeIcon,
  }),
  salary: (salary) => ({
    header: "Expected pay amount",
    content: salary,
    icon: moneyIcon,
  }),
  candidate_friendly_schedule: (schedule) => ({
    header: "Schedule",
    content: schedule,
  }),
  candidate_friendly_job_type: (candidate_friendly_job_type) => ({
    header: "Assignment length",
    content: candidate_friendly_job_type,
  }),
};

const compactHeaderStyle = { margin: "12px 0 4px" };

const IconDetail = ({ content, icon }) => (
  <div className="mb-12 flex items-center">
    <Icon src={icon} className="mr-8" />
    <span className="text-size-16 font-medium">{content}</span>
  </div>
);

const JobRequisitionCopy = ({ job_requisition }) => (
  <div>
    <div className="mb-24">
      <IconDetail content={job_requisition.company_name} icon={companyIcon} />
      <IconDetail
        content={job_requisition.locations_string}
        icon={mapPinIcon}
      />
      {workAmountMapping[job_requisition.work_amount] && (
        <IconDetail
          content={workAmountMapping[job_requisition.work_amount]}
          icon={clockIcon}
        />
      )}
      {job_requisition.category_titles.length > 0 && (
        <IconDetail
          content={_.join(job_requisition.category_titles, ", ")}
          icon={briefcaseIcon}
        />
      )}
    </div>

    {Object.keys(jobDetailsMapping).map((key) => {
      if (!job_requisition[key]) {
        return null;
      }

      const { header, content, icon } = jobDetailsMapping[key](
        job_requisition[key]
      );

      return (
        <React.Fragment key={key}>
          <Header as="h5" style={compactHeaderStyle}>
            {header}
          </Header>
          {icon ? (
            <IconDetail content={content} icon={icon} />
          ) : (
            <div>{content}</div>
          )}
        </React.Fragment>
      );
    })}

    <Header as="h5">Job Description</Header>
    <div dangerouslySetInnerHTML={{ __html: job_requisition.description }} />
    <Header as="h5">Requirements</Header>
    <div dangerouslySetInnerHTML={{ __html: job_requisition.requirements }} />

    {job_requisition.company.description && (
      <>
        <Header as="h5">About {job_requisition.company.name}</Header>
        <div
          dangerouslySetInnerHTML={{
            __html: job_requisition.company.description,
          }}
        />
      </>
    )}
  </div>
);

export default JobRequisitionCopy;
